import { assertNever } from '@gitbook/util-ts';

import type { CustomizationLinkStyle } from './types';

export function LinkStyleIndicator(props: { linkStyle: CustomizationLinkStyle }) {
    switch (props.linkStyle) {
        case 'link':
            return <div className="text-primary text-ui-small">Link</div>;
        case 'button-primary':
            return (
                <div className="rounded-md border border-transparent bg-action-primary px-1 py-0.5 text-inverted text-ui-small">
                    Button
                </div>
            );
        case 'button-secondary':
            return <div className="rounded-md border px-1 py-0.5 text-ui-small">Button</div>;
        default:
            assertNever(props.linkStyle);
    }
}
